"use strict";

var traverseDecisionTree = require('../../../../util/traverseDecisionTree');
/**
 * see shine-products-v2/src/printing/helpers for explanation
 */


module.exports = function (accumulator, order, product, component, options) {
  var decisionTree = options.envelopeTypeForPricing;
  return accumulator + traverseDecisionTree(component, decisionTree);
};